export default "__VITE_ASSET__QG37IRbN__"